import { some } from "lodash";
import { ResultRunner } from "@tvg/ts-types/Race";
import { ResultPayouts } from "../raceResult/components/runnerResult/types";

const getWagerTypesDisplay = (resultRunner: ResultRunner[]): ResultPayouts => ({
  win: some(resultRunner, (runner: ResultRunner) => runner.winPayoff > 0)
    ? "$2"
    : undefined,
  place: some(resultRunner, (runner: ResultRunner) => runner.placePayoff > 0)
    ? "$2"
    : undefined,
  show: some(resultRunner, (runner: ResultRunner) => runner.showPayoff > 0)
    ? "$2"
    : undefined
});

export default getWagerTypesDisplay;
